import type { TimelineType } from './types'

export type ChipKey = 'note' | 'email' | 'call' | 'meeting' | 'task' | 'system'

export const ALL_TYPES: TimelineType[] = ['note', 'call', 'meeting', 'email', 'mail', 'task', 'system']
/** Recente activiteit: everything but system lines (spec-63 E3). */
export const RECENT_TYPES: TimelineType[] = ['note', 'call', 'meeting', 'email', 'mail', 'task']

/** The chips above the timeline (design §4.5); `?type=` in the URL holds the key, none is Alles. */
export const CHIPS: readonly { key: ChipKey | null; label: string; types: TimelineType[] }[] = [
  { key: null, label: 'Alles', types: ALL_TYPES },
  { key: 'note', label: 'Notities', types: ['note'] },
  { key: 'email', label: 'E-mails', types: ['email', 'mail'] },
  { key: 'call', label: 'Gesprekken', types: ['call'] },
  { key: 'meeting', label: 'Meetings', types: ['meeting'] },
  { key: 'task', label: 'Taken', types: ['task'] },
  { key: 'system', label: 'Systeem', types: ['system'] },
]

export function parseChip(value: string | null): ChipKey | null {
  return CHIPS.find((chip) => chip.key !== null && chip.key === value)?.key ?? null
}
